import { NotificationSettingsPage } from '../NotificationSettings';
import { SettingsShell } from './components/SettingsShell';

export const NotificationsSettingsPage = () => {
  return (
    <SettingsShell activeTabPath="notifications" breadcrumbLabel="Notification Settings">
      <NotificationSettingsPage />
    </SettingsShell>
  );
};
